async function main() {
  /** @type string */
  const cookieKey = window.character_name ? `${window.character_name}_history` : "default_history";
  /** @type string | undefined */
  const productHistory = Cookies.get(cookieKey);

  if (productHistory) {
    /** @type HTMLUListElement | null */
    const parent = document.querySelector(".product-history .product-grid");

    if (parent) {
      /** @type string | undefined */
      const shown = parent.dataset.shown;
      const shownParsed = isNaN(parseInt(shown)) ? 4 : parseInt(shown);

      try {
        /** @type Array<{ id: number, handle: string }> */
        const productHistoryParsed = JSON.parse(productHistory);
        /** @type Array<string | null> */
        const responses = await Promise.all(productHistoryParsed.slice(0, shownParsed).map(async (value) => {
          const url = `//${window.location.host}/products/${value.handle}?section_id=card-product-hidden`;
          const response = await fetch(url);

          if (!response.ok) {
            return null;
          }

          return await response.text();
        }));

        const parser = new DOMParser();
        responses.forEach((html) => {
          if (html) {
            const parsedHtml = parser.parseFromString(html, "text/html");
            /** @type HTMLDivElement | null */
            const content = parsedHtml.querySelector(".product-contents");
            if (content) {
              const li = document.createElement("li");
              li.classList.add("grid__item");
              li.append(...content.children);
              parent.append(li);
            }
          }
        })

        if (responses.length) {
          /** @type HTMLElement | null */
          const historyDom = document.querySelector(".product-history");
          if (historyDom) {
            // セクションを表示する
            historyDom.removeAttribute("style");
          }
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
}

main();